import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import keycloakInst from "./Components/Service/keycloak";
import { ReactKeycloakProvider } from "@react-keycloak/web";
// const initOptions = { onLoad: "login-required" };
const initOptions = { onLoad: "check-sso" };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ReactKeycloakProvider authClient={keycloakInst} initOptions={initOptions}>
    <Provider store={store}>
      <App />
    </Provider>
  </ReactKeycloakProvider>
);
